import { MenuDividerProps } from '@chakra-ui/menu';
import { chakra, useStyles } from '@chakra-ui/system';
import * as React from 'react';

export interface IDropdownSectionProps extends MenuDividerProps {
  title?: string;
}

export const DropdownSection: React.FunctionComponent<IDropdownSectionProps> = (props) => {
  const { title, ...rest } = props;
  const styles = useStyles();

  return (
    <div data-klik-indent={title ? 'true' : 'false'}>
      <chakra.hr __css={styles.divider} aria-orientation="horizontal" role="separator" />
      {title && (
        <chakra.p {...rest} __css={styles.groupTitle}>
          {title}
        </chakra.p>
      )}
    </div>
  );
};
